/**
 * Matrix server_name = hostname [ ":" port ]
 * hostname = IPv4address / "[" IPv6address "]" / dns-name
 * https://spec.matrix.org/latest/appendices/#server-name
 *
 * Imported from the matrix-js-sdk: https://github.com/matrix-org/matrix-js-sdk/blob/ebb80a936092ba28fa11124a9b3e427b8f7949bd/src/content-repo.ts#L20
 */
export const MATRIX_SERVER_NAME_REGEX = new RegExp(
  /^(?:(?:\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})|(?:\[[\dA-Fa-f:.]{2,45}])|(?:[A-Za-z\d\-.]{1,255}))(?::\d{1,5})?$/
);

export function isValidMatrixServerName(value: string): boolean {
  return MATRIX_SERVER_NAME_REGEX.test(value);
}
